
import Component from "vue-class-component"
import PageHeader from "@/superannuation/PageHeader.vue"
import HelpIcon from "@/ui/HelpIcon.vue"
import Vue from "vue"
import SelectDropDown from "@/components/SelectDropDown.vue"
import ErrorMessage from "@/components/ErrorMessage.vue"
import {getXsrfHeader, restDownloadFile} from "@/utils/rest"
import {theme} from "@/theme"
import {Platform} from "@/superannuation/PlanService"
import {format, formatISO, parse} from "date-fns"
import {QPopupProxy} from "quasar"

@Component({
  components: {
    ErrorMessage,
    SelectDropDown,
    PageHeader,
    HelpIcon,
    QPopupProxy,
  },
})
export default class AssetsView extends Vue {
  t = theme()
  getXsrfHeader = getXsrfHeader

  $refs: {
    platformSelect: SelectDropDown
    qDateProxy: QPopupProxy
  }

  platform: Platform | null = null
  dataDate: string | null = null
  xhr: XMLHttpRequest | null = null
  rejection: string | null = null

  reportInProgress = false

  dateRule = (v: string) => /^([0-2]\d|(3)[01])(\/)(((0)\d)|((1)[0-2]))(\/)\d{4}$/.test(v)

  get isReportingDisabled(): boolean {
    return this.platform == null
  }

  get uploadUrl(): string | null {
    if (this.isUploadDisabled) {
      return null
    }
    const isoDataDate: string = this.getIsoDataDate()!
    const platformId: string = this.platform!.id
    return `/api/assets?dataDate=${isoDataDate}&platformId=${platformId}`
  }

  get isUploadDisabled(): boolean {
    return this.platform == null || this.dataDate == null || !this.dateRule(this.dataDate)
  }

  get message(): string | null {
    return this.xhr == null
      ? this.rejection == null
        ? null
        : this.rejection
      : JSON.parse(this.xhr.response).message
  }

  private getIsoDataDate(): string | null {
    return this.dataDate == null
      ? null
      : formatISO(parse(this.dataDate, "dd/MM/yyyy", new Date()), {
          representation: "date",
        })
  }

  private platformSelected(platform: Platform | null) {
    this.platform = platform
  }

  private async downloadReport() {
    if (this.platform != null) {
      this.reportInProgress = true
      const now = format(new Date(), "ddMMyyyy")
      const platformName: string = this.platform.name
      await restDownloadFile("/api/assets", `${platformName} - options - ${now}.csv`, {
        platformId: this.platform.id,
      })
      this.reportInProgress = false
    }
  }

  private failed(info: {files: Array<File>; xhr: XMLHttpRequest}) {
    this.xhr = info.xhr
  }

  private rejected(rejectedEntries: Array<{failedPropValidation: string; file: File}>) {
    const entry = rejectedEntries.find(Boolean)
    this.rejection = `File: '${entry!.file.name}' type: '${entry!.file.type}' did not pass: '${
      entry!.failedPropValidation
    }' validation constraint`
  }

  private added() {
    this.rejection = null
  }

  private uploaded() {
    this.xhr = null
  }
}
